"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePopoverStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makePopoverStyles = function makePopoverStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          '& [class*="MuiPaper-root"]': _objectSpread(_objectSpread({
            borderRadius: "".concat(primitives.borderRadii.none, " ").concat(primitives.borderRadii.none, " ").concat(primitives.borderRadii.medium, " ").concat(primitives.borderRadii.medium),
            marginTop: primitives.spacings["1"]
          }, tokens.effects["elevation-0-popover"]), {}, {
            scrollbarWidth: "thin",
            backgroundColor: tokens.colors.background.color,
            '& [class*="MuiList-root"]': {
              '& [class*="MuiListSubheader-root"]:not(:first-of-type)': {
                borderTop: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["row-divider"].rgb)
              }
            }
          })
        }
      }
    }
  };
};

exports.makePopoverStyles = makePopoverStyles;